import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c9b5a65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "video_control" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "progress" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-button" }, null, -1))
const _hoisted_8 = { class: "time-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", {
      ref: "audio",
      class: "audio",
      onPause: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handPlay(1, 2))),
      onPlay: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handPlay(1, 1))),
      onTimeupdate: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.audioTimeUpdate && _ctx.audioTimeUpdate(...args))),
      onLoadedmetadata: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAudioLength())),
      src: _ctx.source,
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args))),
      style: {"display":"none"}
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_select, {
        style: {"width":"100px"},
        modelValue: _ctx.initAudio.playbackRate,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.initAudio.playbackRate) = $event)),
        placeholder: "请选择倍数"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playbackRateOptions, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args)))
      }, [
        (_ctx.initAudio.play)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "p_img iconfont icon-zanting zhant",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handPlay(1, 1)))
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "p_img start iconfont icon-bofang",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handPlay(1, 2)))
              })
            ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_slider, {
          onChange: _ctx.changeAudioTime,
          max: _ctx.initAudio.audioLength,
          class: "commonSlider",
          "format-tooltip": _ctx.formatTooltip,
          modelValue: _ctx.initAudio.currentTime,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.initAudio.currentTime) = $event)),
          "active-color": "#bceeff"
        }, {
          button: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onChange", "max", "format-tooltip", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", null, _toDisplayString(_ctx.formatSecond(_ctx.initAudio.currentTime) || "00:00:00"), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatSecond(_ctx.initAudio.audioLength) || "00:00:00"), 1)
    ])
  ]))
}